import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useGAMInit } from '../hooks/useGAMInit';
const ConsentManagementInit = ()=>{
    const { adsEnabled } = useContext(SessionContext);
    useGAMInit({
        adsEnabled: adsEnabled
    });
    return null;
};
ConsentManagementInit.displayName = 'ConsentManagementInit';
export default ConsentManagementInit;
